// src/hooks/useFetchDiscounts.js
import { useState, useEffect, useCallback, useMemo } from "react";
import { api } from "../api";

export default function useFetchDiscounts() {
  const [rawDiscounts, setRawDiscounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  const loadDiscounts = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await api.getDiscounts();      // JSON array
      setRawDiscounts(data);
    } catch (err) {
      console.error("Error loading discounts:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadDiscounts();
  }, [loadDiscounts]);

  // 1️⃣ parse qualifications and 2️⃣ sort by descending value
  const discounts = useMemo(() => {
    return rawDiscounts
      .map(d => ({
        ...d,
        qualifications:
          typeof d.qualifications === "string"
            ? JSON.parse(d.qualifications)
            : d.qualifications
      }))
      .sort((a, b) => b.value - a.value);
  }, [rawDiscounts]);

  return { discounts, loading, error, refetch: loadDiscounts };
}
